import { FrameContractDTO } from "@jobrad-gmbh/bike-leasing-calculator";
import { CalculatorEnv } from "./calculatorEnv.ts";
import { InputDataUIModel } from "../../../components";

export type ActiveView = "budget" | "leasing";

export enum ConfigurationActionTypes {
  SET_FRAME_CONTRACT = "SET_FRAME_CONTRACT",
  UPDATE_ELEMENT_VISIBILITIES = "UPDATE_ELEMENT_VISIBILITIES",
  TOGGLE_EXPERT_MODE = "TOGGLE_EXPERT_MODE",
  SET_ACTIVE_VIEW = "SET_ACTIVE_VIEW",
}

export type SetFrameContractPayload = {
  frameContract: FrameContractDTO;
  calculatorEnv: CalculatorEnv;
  ctaUrl?: string;
  showHeader?: boolean;
  showBudgetCalculator?: boolean;
};
export type SetFrameContract = {
  type: ConfigurationActionTypes.SET_FRAME_CONTRACT;
  payload: SetFrameContractPayload;
};

export type UpdateElementVisibilitiesPayload = { calculatorInput: Partial<InputDataUIModel> };

export type UpdateElementVisibilities = {
  type: ConfigurationActionTypes.UPDATE_ELEMENT_VISIBILITIES;
  payload: UpdateElementVisibilitiesPayload;
};

export type ToggleExpertModeAction = {
  type: ConfigurationActionTypes.TOGGLE_EXPERT_MODE;
  payload: boolean;
};

export type SetActiveViewAction = {
  type: ConfigurationActionTypes.SET_ACTIVE_VIEW;
  payload: ActiveView;
};

export type ConfigurationAction =
  | SetFrameContract
  | UpdateElementVisibilities
  | ToggleExpertModeAction
  | SetActiveViewAction;
